export const toggleTheme = (): boolean => {
    return document.documentElement.classList.toggle("dark");
};
